module.exports = __webpack_public_path__ + "static/media/P10.235098d7.png";